<template>
  <div class="campaign-type-modal rounded overflow-hidden text-dark bg-white p-3.5">
    <div class="campaign-type-modal__header flex items-center justify-between gap-3 mb-3.5">
      <div class="flex items-center gap-1">
        <svg width="16" height="16" fill="none">
          <use :xlink:href="`#delete`"></use>
        </svg>
        <h2 class="campaign-type-modal__title font-bold mb-0">Delete campaign?</h2>
      </div>
      <button class="campaign-type-modal__close text-base" @click="close"><i class="icon-Close font-bold"></i></button>
    </div>
    <!-- body -->
    <div class="campaign-type-modal__body mb-3.5 text-[13px] leading-5 break-normal">
      Are you sure you want to delete <strong>'{{ meta.campaign.name }}'</strong>? This action cannot be undone.
    </div>
    <!-- end body -->
    <div class="campaign-type-modal__footer-action flex justify-end items-center gap-2">
      <el-button class="font-semibold" @click="close">{{ $t('cancel') }}</el-button>
      <el-button class="font-semibold ml-0" @click="ctaDelete" :loading="loading" icon="el-icon-delete" type="danger">Delete</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DeleteCampaign',
  props: {
    meta: {
      type: null,
      required: '',
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    async ctaDelete() {
      this.loading = true
      await this.$store.dispatch('socialBoostCampaign/deleteCampaign', { id: this.meta.campaign.id, redirect: this.meta.redirectTo })
      if (this.meta.redirectTo) {
        this.$router.push({ name: this.meta.redirectTo })
      }
      this.close()
      this.loading = false
    },
  },
}
</script>
<style lang="scss">
.campaign-type-modal {
  .radio-item-label {
    @apply w-full p-3 rounded border border-[#e4e7ed];

    &.active {
      @apply border-primary;
    }
  }

  // Overwrite el-radio style
  .radio-item-label:hover .el-radio__inner,
  .el-radio__input.is-checked .el-radio__inner {
    @apply border-primary bg-transparent;
  }
  .el-radio__input.is-checked .el-radio__inner {
    &:after {
      @apply w-[7px] h-[7px] bg-primary;
    }
  }
}
</style>
